module.exports = __webpack_public_path__ + "img/3.2.2.350db34b.png";